import { render, staticRenderFns } from "./relatedOrdersDialog.vue?vue&type=template&id=0079a777&scoped=true"
import script from "./relatedOrdersDialog.vue?vue&type=script&lang=js"
export * from "./relatedOrdersDialog.vue?vue&type=script&lang=js"
import style0 from "./relatedOrdersDialog.vue?vue&type=style&index=0&id=0079a777&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0079a777",
  null
  
)

export default component.exports